import { useEffect, useState } from "react";

const useAnnounceKitBanner = () => {
  const [isAnnounceKitBanner, setIsAnnounceKitBanner] = useState({
    status: false,
    height: 0,
  });

  const checkBanner = () => {
    const banner = Array.from(document.querySelectorAll(".announcekit-booster-bar"))
      .find((el) => el.className.includes("active"));

    const newStatus = !!banner;
    const newHeight = banner ? (banner as HTMLElement).offsetHeight : 0;

    setIsAnnounceKitBanner((prev) => {
      if (prev.status !== newStatus || prev.height !== newHeight) {
        return { status: newStatus, height: newHeight };
      }
      return prev;
    });
  };

  useEffect(() => {
    // Check once on initial mount
    checkBanner();

    const observer = new MutationObserver(() => {
      checkBanner();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true, // optional: catches class/style changes
      attributeFilter: ["class", "style"],
    });

    return () => observer.disconnect();
  }, []);

  return isAnnounceKitBanner;
};

export { useAnnounceKitBanner };
